module.exports = __webpack_public_path__ + "static/media/sidebar.2cef7a2a.jpg";